import axios from "axios";
import { useEffect, useState } from "react";
import ResponsiveGrid from "../../commons/ResponsiveGrid";
import Spinner from "../../components/Spinner/Spinner";
import "./MediaRow.css";

const MediaRow = ({ mediaType, state }) => {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorLoading, setErrorLoading] = useState(false)


  useEffect(() => {
    axios.get(`https://dream-screen-backend.onrender.com/api/media/${mediaType}/${state}/en-US/1`).then((res) => {
      setMedia(res.data.results);
      setLoading(false);
    }).catch(err=>{
      console.log('err is', err);
      setLoading(false);
      setErrorLoading(true);
    })
    setLoading(true);
  }, [state]);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        marginTop: "20px",
      }}
      className="gridContainer"
    >
      {loading && (
        <div style={{ position: "absolute", marginTop: "20px" }}>
          <Spinner size={"3em"} />
        </div>
      )}
      {!loading && !errorLoading && <ResponsiveGrid media={media} />}
      {!loading && errorLoading && 
        <div style={{maxWidth: '80%', marginTop: '20px', textAlign: 'center'}}>
          <h2 style={{ letterSpacing: "0.05em" }}>Oops! There was an error loading</h2>
          <br/>
          <h3 style={{ letterSpacing: "0.05em" }}>Don't worry we're working on it 🛠️</h3>
        </div>}
    </div>
  );
};
export default MediaRow;
